import React, { useState, useEffect } from 'react';
import { StyledResetPasswordWrapper } from './index.styles';
import { Button, Grid, Paper, TextField } from '@material-ui/core';
import { resetPassword } from '../../services/api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ResetPasswordPage() {
  const [userName, setUserName] = useState('');
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [invalidLink, setInvalidLink] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const userNameParam = urlParams.get('username');
    const tokenParam = urlParams.get('token');

    if (!userNameParam || !tokenParam) {
      setInvalidLink(true);
      toast.error('Link de restablecimiento inválido. Por favor contacte al administrador.');
    } else {
      setUserName(userNameParam);
      setToken(tokenParam);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error('Las contraseñas no coinciden');
      return;
    }

    if (newPassword.length < 6) {
      toast.error('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    setIsSubmitting(true);

    try {
      await resetPassword(userName, token, newPassword);
      setIsSuccess(true);
      toast.success('Contraseña restablecida exitosamente! Redirigiendo al login...');

      setTimeout(() => {
        window.location.href = '/login';
      }, 3000);
    } catch (error) {
      let errorMessage = 'Error al restablecer contraseña. Por favor intente nuevamente o contacte al administrador.';

      if (error.response && error.response.data) {
        const data = error.response.data;

        if (Array.isArray(data)) {
          const errors = data.map(err => err.description || err.code).join('\n');
          errorMessage = errors || errorMessage;
        } else if (typeof data === 'string') {
          errorMessage = data;
        } else if (data.message) {
          errorMessage = data.message;
        }
      }

      toast.error(errorMessage);
      setIsSubmitting(false);
    }
  };

  if (invalidLink) {
    return (
      <StyledResetPasswordWrapper>
        <ToastContainer />
        <Grid>
          <Paper elevation={10} className="reset-password-paper-container">
            <Grid align='center'>
              <h2>Link Inválido</h2>
              <p>El link de restablecimiento es inválido o ha expirado.</p>
              <p>Por favor contacte al administrador.</p>
            </Grid>
          </Paper>
        </Grid>
      </StyledResetPasswordWrapper>
    );
  }

  if (isSuccess) {
    return (
      <StyledResetPasswordWrapper>
        <ToastContainer />
        <Grid>
          <Paper elevation={10} className="reset-password-paper-container">
            <Grid align='center'>
              <h2>✓ Contraseña Restablecida</h2>
              <p>Su contraseña ha sido restablecida exitosamente.</p>
              <p>Puede iniciar sesión con su nueva contraseña.</p>
              <p>Redirigiendo al login...</p>
            </Grid>
          </Paper>
        </Grid>
      </StyledResetPasswordWrapper>
    );
  }

  return (
    <StyledResetPasswordWrapper>
      <ToastContainer />
      <Grid>
        <Paper elevation={10} className="reset-password-paper-container">
          <Grid align='center'>
            <h2>Restablecer Contraseña</h2>
          </Grid>
          <form onSubmit={handleSubmit}>
            <TextField
              name="userName"
              id="userName"
              value={userName}
              disabled
              label='Usuario'
              fullWidth
              className="mt-2"
            />
            <TextField
              name="newPassword"
              id="newPassword"
              onChange={(e) => setNewPassword(e.target.value)}
              value={newPassword}
              disabled={isSubmitting}
              label='Nueva Contraseña'
              placeholder='Nueva Contraseña'
              type='password'
              fullWidth
              className="mt-2"
              required
            />
            <div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
              La contraseña debe tener:
              <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
                <li>Al menos 6 caracteres</li>
                <li>Al menos una mayúscula (A-Z)</li>
                <li>Al menos un número (0-9)</li>
                <li>Al menos un carácter especial (!@#$%^&*)</li>
              </ul>
            </div>
            <TextField
              name="confirmPassword"
              id="confirmPassword"
              onChange={(e) => setConfirmPassword(e.target.value)}
              value={confirmPassword}
              disabled={isSubmitting}
              label='Confirmar Contraseña'
              placeholder='Confirmar Contraseña'
              type='password'
              fullWidth
              className="mt-2 mb-4"
              required
            />
            <Button
              className="reset-password-btn"
              type="submit"
              disabled={newPassword.length === 0 || confirmPassword.length === 0 || isSubmitting}
              color='primary'
              variant="contained"
              fullWidth
            >
              {isSubmitting ? 'Restableciendo...' : 'Restablecer Contraseña'}
            </Button>
          </form>
        </Paper>
      </Grid>
    </StyledResetPasswordWrapper>
  );
}

export default ResetPasswordPage;
